import { SideBarPrivateContact } from './side-bar-private-contact';

export default SideBarPrivateContact;
